<!-- 头图（普通、视频1.0、视频2.0） -->
<script>
import { get as _get } from 'lodash'
import {
  DEFAULT_BANNER,
  wxMpAppid,
  APPID,
  bApp,
  isMiniBankInsurance
} from 'base/config'
import { CONTRAST_ID } from '../base/config'
import { getUrlParam, parseTime } from 'common/js/common'
import { formatDisplayData } from 'common/js/format'
import { tempToFill } from 'components/liability/common'
import { getVideoList, wxClientSaveOperate } from 'api/index'
import Banner from 'components/banner/banner'
import VideoBanner from 'components/banner/videoBanner'
import VideoIndex from 'components/videoBanner2/videoIndex'
export default {
  name: 'ResultBanner',
  components: {
    VideoBanner,
    VideoIndex,
    Banner
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tmpData: {
      type: Object,
      default () {
        return {}
      }
    },
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    token: [String, Object],
    uuid: {
      type: String,
      default: ''
    },
    isForPresentation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      videoTimer: null,
      allMediaData: {
        firstName: null,
        list: null,
        videoTypeKeys: {},
        waitFlag: true // 是否等待，true:等待，需要再次请求接口
      },
      defaultBanner: false
    }
  },
  computed: {
    // 对比计划书->计划书详情
    isContrastPb () {
      const {
        tmpData: { resultData }
      } = this
      return resultData.insuranceTypeId == CONTRAST_ID
    },
    isVideoOneShow () {
      const {
        isForPresentation,
        tmpData: { insuranceType }
      } = this
      return (
        insuranceType &&
        insuranceType.videoVersion === 1 &&
        (insuranceType.resultVideoUrl ||
          (Array.isArray(insuranceType.videoList) &&
            insuranceType.videoList.length)) &&
        !isForPresentation
      )
    },
    isVideoTwoShow () {
      const {
        isForPresentation,
        tmpData: { insuranceType }
      } = this
      return (
        insuranceType && insuranceType.videoVersion === 2 && !isForPresentation
      )
    },
    insuranceInfor () {
      return this.tmpData.insuranceType
    },
    headBanner () {
      const {
        tmpData: { insuranceType, resultData }
      } = this
      const pbRestBannUrl = insuranceType && insuranceType.pbRestBannUrl
      return pbRestBannUrl || DEFAULT_BANNER[resultData.theme]
    }
  },
  created () {
    const {
      isVideoTwoShow,
      tmpData: { productVideoTypeInfo, insuranceType, resultData }
    } = this
    this.defaultBanner = !(insuranceType && insuranceType.pbRestBannUrl)
    // 视频2.0数据请求
    if (isVideoTwoShow) {
      this.pollingVideoList(resultData, productVideoTypeInfo)
    }
    window.addEventListener('unload', () => {
      this.watchVideoOperate()
    })
  },
  methods: {
    pollingVideoList (resultData, productVideoTypeInfo) {
      this.videoTimer = setInterval(() => {
        this.getVideoList(resultData, productVideoTypeInfo)
      }, 300)
    },
    getVideoList (resultData, productVideoTypeInfo) {
      let self = this
      getVideoList({
        uuid: this.uuid,
        backupFlag: null
      }).then(res => {
        if (res.data.success && res.data.data) {
          for (let k in res.data.data) {
            self.allMediaData[k] = res.data.data[k]
          }
          if (!self.allMediaData.waitFlag) {
            clearInterval(self.videoTimer)
            if (self.allMediaData.list && self.allMediaData.list.length) {
              if (resultData) {
                // 视频类型
                self.allMediaData.list.map(prod => {
                  let videoTypeKey = null
                  if (
                    productVideoTypeInfo &&
                    productVideoTypeInfo[prod.productId]
                  ) {
                    videoTypeKey = productVideoTypeInfo[prod.productId]
                  } else if (
                    prod.videoList.some(v => v.key === resultData.videoTypeKey)
                  ) {
                    videoTypeKey = resultData.videoTypeKey
                  } else {
                    videoTypeKey = prod.videoList[0].videoTypeKey
                  }
                  self.allMediaData.videoTypeKeys[prod.productId] = videoTypeKey
                })
                self.allMediaData.list.map(prod => {
                  const _personOrderList = _get(resultData, 'personData.personOrderList') || []
                  const insuredInfo = _personOrderList.find(p => p.key === 'insuredInfo')
                  let productInfo = resultData.productGroupList[0].prodOrderList.filter(
                    p => p.key === prod.productId
                  )[0]
                  if (productInfo) {
                    let insuranceList = productInfo.mulInsOrderList
                    prod.videoList &&
                      prod.videoList.map(vid => {
                        let h5Config = vid.h5Config && JSON.parse(vid.h5Config)
                        if (h5Config) {
                          // 解析责任数据
                          let liabilities = []
                          insuranceList.map(ins => {
                            let liability = h5Config.liabilities['i' + ins.key]
                            liability &&
                              liability.map(lia => {
                                if (liabilities.length < 6) {
                                  liabilities.push(
                                    tempToFill(
                                      {
                                        productId: productInfo.key,
                                        temp: lia,
                                        data: self.tmpData.calData
                                      },
                                      formatDisplayData
                                    )
                                  )
                                }
                              })
                          })

                          vid.productInfo = {
                            startTime: h5Config.start,
                            endTime: h5Config.end,
                            firstName: self.allMediaData.firstName,
                            name: self.allMediaData.firstName
                              ? `${self.allMediaData.firstName}${
                                  insuredInfo.sex == 1 ? '先生' : '女士'
                                }`
                              : `${insuredInfo.sex == 1 ? '男' : '女'}`,
                            sex: insuredInfo.sex,
                            age: insuredInfo.age,
                            durationDesc: insuranceList[0].iDurationDesc,
                            baofDesc: `${productInfo.totalBaof}元/年`,
                            periodDesc: insuranceList[0].pPeriodDesc,
                            baoeDesc: insuranceList[0].baoeDesc,
                            liabilities
                          }
                        }
                      })
                  }
                })
              }
            }
          }
        }
      })
    },
    watchVideoOperate () {
      if (bApp) return
      const {
        token,
        card,
        uuid,
        tmpData: { insuranceType, resultData }
      } = this
      let vMetadata = localStorage.getItem('PlayingVideoMetadata')
        ? JSON.parse(localStorage.getItem('PlayingVideoMetadata'))
        : null
      if (vMetadata && vMetadata.watch_length) {
        let productName = ''
        if (
          resultData &&
          resultData.productGroupList[0] &&
          resultData.productGroupList[0].prodOrderList
        ) {
          resultData.productGroupList[0].prodOrderList.map(prod => {
            if (prod.key === vMetadata.videoProductId) {
              productName = prod.titleName
            }
          })
        }
        const baseParams = {
          userStrId: getUrlParam('userUuid') || card.userUuid,
          source: 4,
          operate: 'watch_video',
          linkId: uuid,
          businessId: resultData.insuranceTypeId,
          dynamicMsg: [productName],
          extendMsg: `观看时长：${parseTime(
            new Date(
              new Date(0).getTime() + Math.round(vMetadata.watch_length) * 1000
            ),
            '{i}分{s}秒'
          )}`
        }
        // 银保行为记录
        if (isMiniBankInsurance && WeCom.initMiniConfig) {
          WeCom.initMiniConfig(baseParams)
          return
        }
        wxClientSaveOperate({
          token,
          appId: wxMpAppid,
          userAppId: APPID,
          ...baseParams
        })
      }
    },
    childMounted () {
      // 可以获取高度
      this.$emit('done')
    }
  }
}
</script>
<template>
  <!-- [banner] 视频 -->
  <video-banner
    v-if="isVideoOneShow"
    class="top-result-banner"
    :video="insuranceInfor.resultVideoUrl"
    :poster="insuranceInfor.resultVideoImg"
    :banner="insuranceInfor.pbRestBannUrl"
    :video-list="insuranceInfor.videoList"
    @hook:mounted="childMounted"
  />

  <!-- [banner] 视频v2 -->
  <div v-else-if="isVideoTwoShow" class="top-result-banner">
    <video-index
      v-if="!allMediaData.waitFlag"
      :all-media-data="allMediaData"
      :card="card"
      @wxClientSaveOperate="watchVideoOperate"
      @done="childMounted"
    />
  </div>

  <!-- [banner] 常规 -->
  <banner
    v-else-if="title"
    ref="cHeadBanner"
    class="top-result-banner header mb-23"
    :title="title"
    :head-banner="headBanner"
    :insurance-infor="insuranceInfor"
    :conditions="{
      defaultBanner,
      isContrastPb,
    }"
    @hook:mounted="childMounted"
  />
</template>
<style lang="postcss" scoped>
</style>


